module.exports = __webpack_public_path__ + "static/media/iconCopy.96071176.svg";